import {
  INVOICE_SEARCH_TABLE_SIZE_OPTIONS,
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';
import {
  INVOICES_SEARCH_REQUEST,
  INVOICES_SEARCH_SUCCESS,
  INVOICES_SEARCH_ERROR,
  INVOICES_SEARCH_INIT,
  INVOICES_SEARCH_SET_SORT,
  INVOICES_NEXT_PAGE_REQUEST,
  INVOICES_NEXT_PAGE_SUCCESS,
  INVOICES_NEXT_PAGE_ERROR,
  INVOICES_APPROVE_REQUEST,
  INVOICES_APPROVE_SUCCESS,
  INVOICES_APPROVE_ERROR,
  INVOICES_SEND_BY_EMAIL_REQUEST,
  INVOICES_SEND_BY_EMAIL_SUCCESS,
  INVOICES_SEND_BY_EMAIL_ERROR,
  CREATE_INVOICE_IN_LIBEO_SUCCESS,
  INVOICES_DEVALIDATE_REQUEST,
  INVOICES_DEVALIDATE_SUCCESS,
  INVOICES_DEVALIDATE_ERROR,
  INVOICES_ACCEPT_REQUEST,
  INVOICES_ACCEPT_SUCCESS,
  INVOICES_ACCEPT_ERROR,
  INVOICES_DELETE_REQUEST,
  INVOICES_DELETE_SUCCESS,
  INVOICES_DELETE_ERROR,
  GET_PAY_INVOICE_URL_SUCCESS,
  RESET_PAY_INVOICE_URL,
  MASS_INVOICES_APPROVE_REQUEST,
  MASS_INVOICES_APPROVE_SUCCESS,
  INVOICES_ADD_COMMENT_SUCCESS,
  INVOICES_ADD_COMMENT_ERROR,
  INVOICES_PREVALIDATE_ERROR,
  INVOICES_PREVALIDATE_SUCCESS,
  CANCEL_INVOICE_PREVALIDATION_SUCCESS,
  INVOICES_PAID_OUTSIDE_SUCCESS,
  MASS_INVOICES_PAID_OUTSIDE_SUCCESS,
  MASS_INVOICES_PAID_OUTSIDE_REQUEST,
  INVOICES_PAID_OUTSIDE_REQUEST,
  INVOICES_DEVALIDATE_AND_APPROVE_REQUEST,
  INVOICES_DEVALIDATE_AND_APPROVE_ERROR,
  INVOICES_NEXT_PAGE_NOT_NEEDED,
  OPEN_INVOICE_REQUEST,
  OPEN_INVOICE_SUCCESS,
  OPEN_INVOICE_ERROR,
  DOWNLOAD_INVOICE_REQUEST,
  DOWNLOAD_INVOICE_SUCCESS,
  DOWNLOAD_INVOICE_ERROR,
  STORE_FILE,
  DOWNLOAD_DOCUMENTS_REQUEST,
  DOWNLOAD_DOCUMENTS_SUCCESS,
  DOWNLOAD_DOCUMENTS_ERROR,
  INVOICES_DEVALIDATE_AND_APPROVE_SUCCESS,
} from '../actions';
import { mapInvoicesResponseToReduxStore } from '../helpers';

const initialState = {
  data: [],
  totals: {
    totalTVA: 'N/A',
    totalHT: 'N/A',
    totalTTC: 'N/A',
  },
  meta: {},
  storedPayload: {},
  paymentLink: '',
  tableItemsPerPage: INVOICE_SEARCH_TABLE_SIZE_OPTIONS[0],
  tableCurrentPage: 1,
  tableSort: null,
  status: STATUS_NOT_REQUESTED,
  approveStatus: STATUS_NOT_REQUESTED,
  invoicesOpeningList: [],
  invoicesDownloadingList: [],
  invoicesSendingList: [],
  approveInProgressId: '',
  error: '',
  file: {},
  downloadDocumentsIsLoading: false,
};

export const invoiceSearch = (state = initialState, action) => {
  switch (action.type) {
    case INVOICES_SEARCH_INIT:
      return { ...initialState };

    case INVOICES_SEARCH_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
        storedPayload: initialState.storedPayload,
        tableCurrentPage: initialState.tableCurrentPage,
      };

    case INVOICES_SEARCH_SUCCESS: {
      const { totalsObject, data, meta, payload } = action.payload;
      return {
        ...state,
        data,
        meta,
        totals: totalsObject || state.totals || initialState.totals,
        storedPayload: payload,
        status: STATUS_SUCCESS,
      };
    }

    case INVOICES_SEARCH_ERROR:
      return {
        ...state,
        error: action.payload.error?.message || 'error',
        totals: initialState.totals,
        status: STATUS_ERROR,
      };

    case INVOICES_SEARCH_SET_SORT:
      return {
        ...state,
        tableSort: action.payload.sort,
      };

    case INVOICES_NEXT_PAGE_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
        tableItemsPerPage: action.payload.itemsPerPage,
        tableCurrentPage: action.payload.page,
      };

    case INVOICES_NEXT_PAGE_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        meta: action.payload.meta,
        status: STATUS_SUCCESS,
      };

    case INVOICES_NEXT_PAGE_NOT_NEEDED:
      return { ...state, status: STATUS_SUCCESS };

    case INVOICES_NEXT_PAGE_ERROR:
      return {
        ...state,
        error: action.payload.error?.message || 'error',
        status: STATUS_ERROR,
      };

    case INVOICES_DELETE_REQUEST:
    case INVOICES_ACCEPT_REQUEST:
    case INVOICES_APPROVE_REQUEST:
    case INVOICES_PAID_OUTSIDE_REQUEST:
    case INVOICES_DEVALIDATE_AND_APPROVE_REQUEST:
    case INVOICES_DEVALIDATE_REQUEST:
      return {
        ...state,
        approveStatus: STATUS_LOADING,
        approveInProgressId: action.payload.documentId,
        error: '',
      };

    case MASS_INVOICES_PAID_OUTSIDE_REQUEST:
    case MASS_INVOICES_APPROVE_REQUEST:
      return {
        ...state,
        approveStatus: STATUS_LOADING,
        approveInProgressId: action.payload.invoicesId,
        error: '',
      };

    case MASS_INVOICES_PAID_OUTSIDE_SUCCESS:
    case MASS_INVOICES_APPROVE_SUCCESS: {
      const fetchedInvoices = mapInvoicesResponseToReduxStore(
        action.payload.documents
      );
      const updatedData = state.data.filter(
        (invoice) => !fetchedInvoices.find((f) => f.id === invoice.id)
      );
      return {
        ...state,
        data: updatedData,
        meta: {
          ...state.meta,
          total: state.meta.total - state.approveInProgressId.length,
        },
        approveStatus: STATUS_SUCCESS,
        approveInProgressId: initialState.approveInProgressId,
      };
    }

    case INVOICES_DEVALIDATE_SUCCESS:
    case INVOICES_PAID_OUTSIDE_SUCCESS:
    case CANCEL_INVOICE_PREVALIDATION_SUCCESS:
    case INVOICES_DEVALIDATE_AND_APPROVE_SUCCESS:
    case INVOICES_DELETE_SUCCESS:
    case INVOICES_PREVALIDATE_SUCCESS:
    case INVOICES_APPROVE_SUCCESS:
    case INVOICES_ACCEPT_SUCCESS: {
      const isAllFilter = state.storedPayload?.paymentStatus === 'all';
      const updatedData = state.data
        .map((invoice) => {
          if (invoice.id === action.payload.invoiceData.id) {
            if (isAllFilter) {
              return {
                ...action.payload.invoiceData,
                paymentStatus: 'accepted',
              };
            }
            return null;
          }
          return invoice;
        })
        .filter(Boolean);

      const updatedMeta = {
        ...state.meta,
        total: isAllFilter ? state.meta.total : state.meta.total - 1,
      };

      return {
        ...state,
        data: updatedData,
        meta: updatedMeta,
        approveStatus: STATUS_SUCCESS,
        approveInProgressId: initialState.approveInProgressId,
      };
    }

    case INVOICES_ADD_COMMENT_SUCCESS:
      return {
        ...state,
        data: state.data.map((invoice) =>
          invoice.id === action.payload.invoiceData.id
            ? { ...invoice, ...action.payload.invoiceData }
            : invoice
        ),
      };

    case INVOICES_ADD_COMMENT_ERROR:
    case INVOICES_DELETE_ERROR:
    case INVOICES_ACCEPT_ERROR:
    case INVOICES_PREVALIDATE_ERROR:
      return { ...state, error: action.payload.error?.message || 'error' };

    case INVOICES_APPROVE_ERROR:
    case INVOICES_DEVALIDATE_AND_APPROVE_ERROR:
    case INVOICES_DEVALIDATE_ERROR:
      return {
        ...state,
        error: action.payload.error?.message || 'error',
        approveStatus: STATUS_ERROR,
        approveInProgressId: initialState.approveInProgressId,
      };

    case CREATE_INVOICE_IN_LIBEO_SUCCESS:
      return {
        ...state,
        data: state.data.map((invoice) =>
          invoice.id === action.payload.invoiceData.id
            ? { ...invoice, ...action.payload.invoiceData }
            : invoice
        ),
      };

    case GET_PAY_INVOICE_URL_SUCCESS:
      return { ...state, paymentLink: action.payload.url };

    case RESET_PAY_INVOICE_URL:
      return { ...state, paymentLink: initialState.paymentLink };

    case OPEN_INVOICE_REQUEST:
      return {
        ...state,
        invoicesOpeningList: [
          ...state.invoicesOpeningList,
          action.payload.documentId,
        ],
      };

    case OPEN_INVOICE_SUCCESS:
    case OPEN_INVOICE_ERROR:
      return {
        ...state,
        invoicesOpeningList: state.invoicesOpeningList.filter(
          (id) => id !== action.payload.documentId
        ),
      };

    case DOWNLOAD_INVOICE_REQUEST:
      return {
        ...state,
        invoicesDownloadingList: [
          ...state.invoicesDownloadingList,
          action.payload.documentId,
        ],
      };

    case DOWNLOAD_INVOICE_SUCCESS:
    case DOWNLOAD_INVOICE_ERROR:
      return {
        ...state,
        invoicesDownloadingList: state.invoicesDownloadingList.filter(
          (id) => id !== action.payload.documentId
        ),
      };

    case INVOICES_SEND_BY_EMAIL_REQUEST:
      return {
        ...state,
        invoicesSendingList: [
          ...state.invoicesSendingList,
          action.payload.documentId,
        ],
      };

    case INVOICES_SEND_BY_EMAIL_SUCCESS:
    case INVOICES_SEND_BY_EMAIL_ERROR:
      return {
        ...state,
        invoicesSendingList: state.invoicesSendingList.filter(
          (id) => id !== action.payload.documentId
        ),
      };

    case STORE_FILE:
      return {
        ...state,
        file: {
          documentId: action.payload.documentId,
          fileData: action.payload.fileData,
        },
      };

    case DOWNLOAD_DOCUMENTS_REQUEST:
      return { ...state, downloadDocumentsIsLoading: true };

    case DOWNLOAD_DOCUMENTS_SUCCESS:
    case DOWNLOAD_DOCUMENTS_ERROR:
      return { ...state, downloadDocumentsIsLoading: false };

    default:
      return state;
  }
};
